<template>
  <div class="digit-wrapper">
    <div class="banner-video">
      <video :src="videoUrl" muted class="background-video" loop autoplay x5-video-player-type="h5">
        <source :src="videoUrl" type="video/mp4" />
      </video>
      <!-- <div class="video-display-btn">
        <a class="action-btn btn1" @click="$router.push('/works/180232217665006233')"></a>
        <a class="action-btn btn2" @click="$router.push('/works/150959802141376524')"></a>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoUrl: 'https://vcan-web.oss-cn-shanghai.aliyuncs.com/video/268495540277275289.mp4'
    }
  }
}

</script>
<style lang="scss" scoped>
.digit-wrapper {
  width: 100%;
  position: relative;
  height: 100vh;

  .banner-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .video-display-btn {
      position: relative;
      bottom: 30vh;
      display: flex;
      justify-content: center;
      align-items: center;

      .action-btn {
        display: block;
        width: 120 * 2.5px;
        height: 56 * 2.5px;
      }

      .btn1 {
        background-image: url('../../assets/images/home/sz.png');
        background-size: cover;
        background-position: center center;

        &:hover {
          background-image: url('../../assets/images/home/sz-active.png');
        }
      }

      .btn2 {
        margin-left: 20px;
        background-image: url('../../assets/images/home/wz.png');
        background-size: cover;
        background-position: center center;

        &:hover {
          background-image: url('../../assets/images/home/wz-active.png');
        }
      }
    }
  }

}
</style>